module.exports = __webpack_public_path__ + "img/logo.c3d7f4c6.png";